import React, { useState, useEffect } from 'react';
import { Phone, Smartphone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Services', href: '#services' },
    { name: 'Process', href: '#process' },
    { name: 'Why Us', href: '#why-us' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg shadow-black/10'
          : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-40 sm:h-48">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-3">
            <img
              src={companyInfo.logo}
              alt={companyInfo.fullName}
              className="h-32 sm:h-40 w-auto rounded-2xl"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-neutral-700 hover:text-brand transition-colors duration-200 text-sm font-medium tracking-wide"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <div className="flex flex-col items-end text-sm">
              <a
                href={`tel:${companyInfo.phoneTel}`}
                className="flex items-center gap-2 text-neutral-700 hover:text-brand transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="font-medium">{companyInfo.phone}</span>
              </a>
              <a
                href={`tel:${companyInfo.mobileTel}`}
                className="flex items-center gap-2 text-neutral-700 hover:text-brand transition-colors"
              >
                <Smartphone className="w-4 h-4" />
                <span className="font-medium">{companyInfo.mobile}</span>
              </a>
            </div>
            <Button
              asChild
              className="bg-brand hover:bg-brand-dark text-white font-semibold px-6"
            >
              <a href="#contact">Get Free Quote</a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-neutral-800 p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-neutral-200 py-4">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-neutral-700 hover:text-brand transition-colors px-4 py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <div className="px-4 pt-4 border-t border-neutral-200">
                <a
                  href={`tel:${companyInfo.phoneTel}`}
                  className="flex items-center gap-2 text-neutral-700 mb-2"
                >
                  <Phone className="w-4 h-4" />
                  <span>{companyInfo.phone}</span>
                </a>
                <a
                  href={`tel:${companyInfo.mobileTel}`}
                  className="flex items-center gap-2 text-neutral-700 mb-4"
                >
                  <Smartphone className="w-4 h-4" />
                  <span>{companyInfo.mobile}</span>
                </a>
                <Button
                  asChild
                  className="w-full bg-brand hover:bg-brand-dark text-white font-semibold"
                >
                  <a href="#contact">Get Free Quote</a>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
